<template>
    <div class="row feedback-bar text-left">
        <div class="col col-3 col-sm-2 col-md-1">
            <div class="feedback-bar-picture"><slot name="picture"></slot></div>
        </div>

        <div class="col col-9 col-sm-10 col-md-11">
            <div class="row">
                <div class="col col-12 col-md-4">
                    <div class="row margintop-resp">
                        <div class="col col-8 col-md-12">
                            <p class="headerUppercase"><slot name="header"></slot></p>
                        </div>
                        <div class="col col-4 col-md-12">
                            <p class="amount"><slot name="amount"></slot></p>
                        </div>
                    </div>
                </div>

                <div class="col col-12 col-md-4">
                    <div class="row">
                        <div class="col col-8 col-md-12">
                            <p class="headerUppercase"><slot name="headerMiddle"></slot></p>
                        </div>
                        <div class="col col-4 col-md-12">
                            <p class="amount"><slot name="amountMiddle"></slot></p>
                        </div>
                    </div>
                </div>

                <div class="col col-12 col-md-4 text-right">
                    <slot name="transaction"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
};
</script>

<style>
</style>